import {Component, Input, OnInit} from '@angular/core';
import {Asset, ASSET_STATUS_BUYER_ABANDONED, assetMessage, AuditAssetMove} from '../../shared/domain/item';
import {DialogService} from '@rbaip/ui-component';
import {ItemSummaryItemService} from "../../shared/asset/item-summary-item.service";
import {MatDialogRef} from "@angular/material/dialog";
import {MoveAssetsComponent} from "../move-assets/move-assets.component";

@Component({
  selector: 'lib-item-summary-resell-abandoned-asset',
  templateUrl: './resell-abandoned-asset.component.html',
  styleUrls:['./resell-abandoned-asset.component.scss']
})
export class ResellAbandonedAssetComponent implements  OnInit{

  @Input('asset') assets: Asset[];
  @Input('itemService') itemService: ItemSummaryItemService;
  @Input('auditAssetMove') auditAssetMove: AuditAssetMove;

  public resellButtonDisable : boolean;
  public selectedAsset : Asset;

  constructor( private dialogService: DialogService,
               private dialogRef: MatDialogRef<MoveAssetsComponent>) {
  }

  ngOnInit() {
    this.selectedAsset = this.assets[0];
    this.validateAsset();
  }

  public resellAbandonedAsset(): void {
    let selectedItem = this.selectedAsset;
    if ( selectedItem.destinationEquipmentId ){
      this.dialogService.showMessageDialog( assetMessage.assetMoveToRelistedConfirmation );
      return;
    }
    this.dialogService.showProgress();
    this.itemService.resellAbandonedEquip(selectedItem.equipId)
      .subscribe(itemResponse => {
        let message;
        if ( itemResponse && itemResponse.error ){
          message = 'Error while re-selling asset. Please contact techsupport.';
        } else if ( itemResponse.status === 'Success' ) {
          message = 'Asset re-consigned successfully.';
        } else {
          message = itemResponse.message;
        }
        this.dialogService.showMessage(message);
        this.dialogRef.close(true);
        this.dialogService.hideProgress();
      });
  }

  private validateAsset() : void {
    this.checkAssetStatus();
    this.checkRelistedItem();
  }

  public checkAssetStatus(): void {
    this.resellButtonDisable = !(this.selectedAsset && this.selectedAsset.assetStatusId === ASSET_STATUS_BUYER_ABANDONED);
  }

  private checkRelistedItem(): void {
    const relistedItemsYn = this.assets.some(asset => asset.destinationEquipmentId);
    if (relistedItemsYn) {
      this.resellButtonDisable = true;
      this.auditAssetMove.destinationType = null;
      this.dialogService.showMessageDialog(assetMessage.assetMoveToRelistedConfirmation);
      return;
    }
  }

}
